import io from 'socket.io-client';
import AsyncStorage from '@react-native-async-storage/async-storage';
import Fingerprint from 'fingerprintjs';

// One socket per tab. Listeners are attached once per socket and route to the
// latest handlers, so socket.io's own reconnects never add duplicates.
const RESERVED_EVENTS = ['connect', 'disconnect', 'connect_error'];

let socket = null;
let socketToken = null;
let pendingConnect = null;
let handlers = {};

const dispatch = (event, ...args) => handlers[event]?.(...args);

export const setSocketHandlers = next => {
  handlers = next;
};

export const getSocket = () => socket;

const openSocket = async () => {
  const token = await AsyncStorage.getItem('access_token');
  if (socket?.active && socketToken === token) {
    return socket;
  }
  if (socket) {
    socket.offAny();
    socket.removeAllListeners();
    socket.disconnect();
  }

  socket = io.connect('wss://socket.groovepacker.com/v1', {
    path: '/socket/socket.io',
    reconnect: true,
    query: {
      fingerprint: new Fingerprint({
        canvas: true,
        screen_resolution: true
      }).get(),
      token
    },
    cors: {
      cookie: false,
      host: 'localhost:19006',
      origin: 'http://localhost:5000',
      credentials: true
    },
    transports: ['websocket', 'polling']
  });
  socketToken = token;

  RESERVED_EVENTS.forEach(event => socket.on(event, (...args) => dispatch(event, ...args)));
  socket.onAny(dispatch);
  return socket;
};

// Concurrent callers (App and Main mount in the same tick) share one attempt.
export const connectSocket = () => {
  if (!pendingConnect) {
    pendingConnect = openSocket().finally(() => {
      pendingConnect = null;
    });
  }
  return pendingConnect;
};
